import React, { useState, useEffect } from "react";
import CardOtp from "./card-otp";
import CardDetails from "./card-details";
import ErrorView from "./error-view";
import CardPin from "./card-pin";
import SuccessView from "../success";
import Card3DS from "./card-3ds";
import { useViewContext } from "../../contexts/view.context";
import "./index.scss";
import Transfer from "../transfer";

const Card = () => {
  const { view, setView } = useViewContext();
  const [errMssg, setErrMssg] = useState("");
  const [bodyContent, setBodyContent] = useState("");
  const [JWT, setJWT] = useState("");
  const [MD, setMD] = useState("");

  return (
    <div className="cardPayment">
      {view === "card" ? (
        <CardDetails/>
      ) : null}
      {view === "pin" ? <CardPin /> : null}
      {view === "otp" ? <CardOtp /> : null}
      {view === "success" ? (
        <SuccessView/>
      ) : null}
      {view === "error" ? <ErrorView errMssg={errMssg} /> : null}
      {view === "transfer" ? <Transfer/> : null}
      {view === "card3ds" ? (
        <Card3DS />
      ) : null}
    </div>
  );
};

export default Card;
